
  import { MajorConfig, translateValueByKey } from '@kunlun/dependencies';
  import { FormItemRule, OioButton, OioForm, OioFormInstance, OioFormItem, OioInputPassword } from '@kunlun/vue-ui-antd';
  import { defineComponent, onMounted, PropType, reactive, ref } from 'vue';
  import ResetPasswordLayout from './layout/ResetPasswordLayout.vue';
  import { ResetPasswordData } from './typing';
  import { useResetPassword } from './useResetPassword';
  
  export default defineComponent({
    name: 'ForgetPassword',
    components: {
      OioButton,
      OioForm,
      OioFormItem,
      OioInputPassword,
      ResetPasswordLayout
    },
    inheritAttrs: false,
    props: {
      setFormInstance: {
        type: Function as PropType<(instance: OioFormInstance | undefined) => void>
      },
      formData: {
        type: Object as PropType<ResetPasswordData>,
        required: true
      },
      verificationRules: {
        type: Object as PropType<Record<string, FormItemRule[]>>
      },
      majorConfig: {
        type: Object as PropType<MajorConfig>
      },
      copyrightYear: {
        type: String
      },
      onOk: {
        type: Function
      }
    },
    setup(props) {
      const formRef = ref<OioFormInstance>();
  
      const data = reactive<ResetPasswordData>(props.formData || {});
  
      const { formLayout, formButtonLayout, loading, logo, copyright, onOk } = useResetPassword(props);
  
      onMounted(() => {
        props.setFormInstance?.(formRef.value);
      });
  
      return {
        formRef,
        formLayout,
        formButtonLayout,
        data,
        loading,
        logo,
        copyright,
  
        onOk,
        translateValueByKey
      };
    }
  });
  